import React from 'react'

export interface IModalContext {
  wasteTypeFilterModal: boolean
  setWasteTypeFilterModal: (value: boolean) => void
  openMessageModal: (msg: string, cb?: () => void) => void
}

export const ModalContext = React.createContext<IModalContext>({
  wasteTypeFilterModal: false,
  setWasteTypeFilterModal: () => console.warn('setWasteTypeFilterModal not implemented in the currentContext'),
  openMessageModal: () => console.warn('Message modal not implemented')
})

export const useModalContext = (): IModalContext => React.useContext(ModalContext)
